import { ConfigCommonHeader } from '@net7/boilerplate-common';

export default {
  logo: {
    title: 'Aitia',
    anchor: {
      href: 'http://aitia.muruca.cloud/',
    },
  },
  nav: {
    items: [],
  },
} as ConfigCommonHeader;
